import { render, staticRenderFns } from "./RatingScaleSelector.vue?vue&type=template&id=c75ce804&scoped=true&"
import script from "./RatingScaleSelector.vue?vue&type=script&lang=ts&"
export * from "./RatingScaleSelector.vue?vue&type=script&lang=ts&"
import style0 from "./RatingScaleSelector.vue?vue&type=style&index=0&id=c75ce804&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75ce804",
  null
  
)

export default component.exports